export default __webpack_public_path__ + "static/67da9da8-4b53-4407-9184-abce69bfc8b5-fafb89bcfdf9ceaea242df6267c50502.woff";